import { useAcceptOrganizationPaymentPlanPendingChangesMutation } from '@/services/organizations';
import { toast } from '@palmetto/palmetto-components';

export const useAcceptPaymentPlanAction = ({ id }: { id: string }) => {
  const [acceptPaymentPlan, { isLoading: isAccepting }] = useAcceptOrganizationPaymentPlanPendingChangesMutation();
  const handleAcceptPaymentPlan = async () => {
    try {
      await acceptPaymentPlan({ settingsId: id }).unwrap();
      toast.success('Payment plan accepted successfully');
    } catch (error) {
      console.error('Failed to accept payment plan proposed change', error);
      toast.error('Failed to accept payment plan proposed change');
    }
  };
  return { handleAcceptPaymentPlan, isAccepting };
};
